















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'
import { downloadFile } from '@/utils/fileHelper'

@Component({
  components: { Icon },
  props: {
    url: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => {
      }
    }
  }
})
export default class ButtonDownloadReport extends Vue {
  isLoading: boolean = false

  async download () {
    if (this.$props.disabled || !this.$props.url) {
      this.$emit('click')
      return
    }
    this.isLoading = true
    const query = JSON.parse(JSON.stringify(this.$props.params))
    delete query.limit
    delete query.skip
    await downloadFile(this.$props.url, query)
    this.isLoading = false
  }
}
